module.exports = __webpack_public_path__ + "static/media/receive-btn.5567b378.png";